export const state = {
  routes: [],
  isDrawing: false,
  maxSpeed: null,
  fullHeightMap: true,
  tableData: null,
  routeSegment: null,
  vehicleColors: [
    '#FB8C00',
    '#3e7a78',
    '#3e587a',
    '#453e7a',
    '#6f3e7a',
    '#7a3e65',
    '#627a3e',
    '#7a633e'
  ],
  displayRouteDirections: false,
  legendSource: null,
  displayTable: false,
  searchObject: {},
  routeOptimizationData: {},
  privateDriveRoutes: [],
  businessDriveRoutes: []
}

export const mutations = {
  SET_ROUTES(state, mapDetailsObj) {
    state.routes = mapDetailsObj.routes
    state.legendSource = mapDetailsObj.legendSource
    state.routeOptimizationData = mapDetailsObj.routeOptimizationData
  },
  SET_MAX_SPEED(state, maxSpeed) {
    state.maxSpeed = maxSpeed
  },
  SET_IS_FULL_HEIGHT(state, isFullHeight) {
    state.fullHeightMap = isFullHeight
  },
  SET_TABLE_DATA(state, tableData) {
    state.tableData = tableData
  },
  SET_ROUTE_SEGMENT(state, segment) {
    state.routeSegment = segment
  },
  SET_IS_DRAWING(state, isDrawing) {
    state.isDrawing = isDrawing
  },
  SET_DISPLAY_DIRECTIONS(state, displayDirections) {
    state.displayRouteDirections = displayDirections
  },
  SET_DISPLAY_TABLE(state, displayTable) {
    state.displayTable = displayTable
  },
  SET_SEARCH_OBJECT(state, searchObject) {
    state.searchObject = searchObject
  },
  SET_PRIVATE_DRIVE_ROUTES(state, privateDriveRoutes) {
    state.privateDriveRoutes = privateDriveRoutes
  },
  SET_BUSINESS_DRIVE_ROUTES(state, businessDriveRoutes) {
    state.businessDriveRoutes = businessDriveRoutes
  }
}

export const actions = {
  saveRoutes({ commit }, mapDetailsObj) {
    commit('SET_ROUTES', mapDetailsObj)
  },
  changeMaxSpeed({ commit }, maxSpeed) {
    commit('SET_MAX_SPEED', maxSpeed)
  },
  changeMapHeight({ commit }, isFullHeight) {
    commit('SET_IS_FULL_HEIGHT', isFullHeight)
  },
  changeTableData({ commit }, tableData) {
    commit('SET_TABLE_DATA', tableData)
  },
  displayRouteSegment({ commit }, routeSegment) {
    commit('SET_ROUTE_SEGMENT', routeSegment)
  },
  isDrawing({ commit }, isDrawing) {
    commit('SET_IS_DRAWING', isDrawing)
  },
  displayDirections({ commit }, displayDirections) {
    commit('SET_DISPLAY_DIRECTIONS', displayDirections)
  },
  setDisplayTable({ commit }, displayTable) {
    commit('SET_DISPLAY_TABLE', displayTable)
  },
  setSearchObject({ commit }, searchObject) {
    commit('SET_SEARCH_OBJECT', searchObject)
  },
  setPrivateDriveRoutes({ commit }, privateDriveRoutes) {
    commit('SET_PRIVATE_DRIVE_ROUTES', privateDriveRoutes)
  },
  setBusinessDriveRoutes({ commit }, businessDriveRoutes) {
    commit('SET_BUSINESS_DRIVE_ROUTES', businessDriveRoutes)
  }
}

export const namespaced = true
